import { sendPasswordResetEmail,getAuth } from 'firebase/auth';
import React, { useState } from 'react';
import {Link} from 'react-router-dom';
import { toast } from 'react-toastify';
import OAuth from '../components/OAuth';

const ForgotPassword = () => {

  const [email,SetEmail] = useState("");
  
  const onChange = (e) => {
    SetEmail(e.target.value);

  }

  const onSubmit = async (e) => {
    e.preventDefault();

    try {

      const auth = getAuth();
      await sendPasswordResetEmail(auth,email);

      toast.success("Email was sent!");
      
    } catch (error) {
      toast.error("Could not send reset Email");
    }
  }



  return (
    <section>
      <h1 className="text-3xl text-center mt-6 font-bold">Forgot Password</h1>

      <div className="flex justify-center flex-wrap items-center px-6 py-12 mx-auto max-w-6xl">
        <div className="md:w-[67%] lg:w-[50%] mb-12 md:mb-6">
          <img className="w-full rounded-2xl"  alt="key" src="https://images.unsplash.com/flagged/photo-1564767609342-620cb19b2357?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8a2V5fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60" />
        </div>
        <div className="w-full md:w-[67%] lg:w-[40%] lg:ml-20">
          <form onSubmit={onSubmit}>
            <input id="email" type="email" value={email} onChange={onChange} placeholder="Email Address" className="mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"/>

            <div className="flex justify-between whitespace-nowrap text-sm sm:text-lg">
              <p className="mb-6">Don't have an account? <Link to="/sign-up" className="text-red-600 hover:text-red-700 transition duration-200 ease-in-out">Register</Link> </p>
              <p>
                <Link to="/sign-in" className="text-blue-600 hover:text-blue-800 transition duration-200 ease-in-out">Sign In Instead?</Link>
              </p>
            </div>
            <button className="w-full bg-blue-600 text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-blue-700 transition duration-150 ease-in-out hover:shadow-lg active:bg-blue-800" type="submit">Send Reset Email</button>
                <div className="my-4 before:border-t flex before:flex-1  before:border-gray-300 after:border-t after:flex-1 items-center after:border-gray-300">
                <p className="text-center font-semibold mx-4">OR</p>
                </div>
                <OAuth />
          </form>
          
        </div>
      </div>
    </section>
  )
}

export default ForgotPassword